/** Múi giờ đại diện của từng thị trường, dùng cho tooltip giờ địa phương. */
export const MUI_GIO_THI_TRUONG: Record<string, string> = {
  EN: 'America/New_York',
  PT: 'America/Sao_Paulo',
  VI: 'Asia/Ho_Chi_Minh',
  ES: 'Europe/Madrid',
  HI: 'Asia/Kolkata',
};

export const MUI_GIO_APP = 'Asia/Ho_Chi_Minh';

function gio(iso: string, mui: string): string {
  return new Date(iso).toLocaleTimeString('vi-VN', {
    timeZone: mui,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

/** Giờ hiển thị trên thẻ: luôn theo GMT+7. */
export function gioVn(iso: string): string {
  return gio(iso, MUI_GIO_APP);
}

/** Tooltip: giờ GMT+7 kèm giờ địa phương của thị trường. */
export function moTaGio(iso: string, market: string): string {
  const mui = MUI_GIO_THI_TRUONG[market];
  const ngay = new Date(iso).toLocaleDateString('vi-VN', { timeZone: MUI_GIO_APP });

  if (!mui || mui === MUI_GIO_APP) return `${gioVn(iso)} ngày ${ngay} (GMT+7)`;
  return `${gioVn(iso)} ngày ${ngay} (GMT+7) · ${gio(iso, mui)} giờ ${market}`;
}

/** Ngày `YYYY-MM-DD` theo giờ Việt Nam. */
export function khoaNgayVn(d: Date): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: MUI_GIO_APP,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(d);
}

export function congNgay(khoa: string, so: number): string {
  const d = new Date(`${khoa}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + so);
  return d.toISOString().slice(0, 10);
}

export function congThang(khoa: string, so: number): string {
  const d = new Date(`${khoa}T00:00:00Z`);
  d.setUTCDate(1);
  d.setUTCMonth(d.getUTCMonth() + so);
  return d.toISOString().slice(0, 10);
}

export const TEN_THU = ['Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7', 'Chủ nhật'];

export function ngayTrongKhoa(khoa: string): string {
  return khoa.slice(8, 10);
}

/** `05 – 11/10/2026` cho lịch tuần, `Tháng 10/2026` cho lịch tháng. */
export function nhanKhoang(view: 'week' | 'month', from: string, to: string): string {
  if (view === 'month') return `Tháng ${from.slice(5, 7)}/${from.slice(0, 4)}`;
  return `${from.slice(8, 10)} – ${to.slice(8, 10)}/${to.slice(5, 7)}/${to.slice(0, 4)}`;
}
